import React, { FC } from "react";
import { CarouselModal } from "@propertyguru/hive-ui-widgets/agentnet-widgets";
const animations = [
  `https://cdn.pgimgs.com/hive-ui/static/v0.2.9/json/listing-creation-v3/switchToNew-RefreshedUI-v2.json`,
];

interface Props {
  show: boolean;
  onOk: () => void;
  onCancel: () => void;
}

const ListingFlowToggleModal: FC<Props> = (props) => {
  const { show, onCancel, onOk } = props;
  return (
    <CarouselModal
      className="hive-modal"
      show={show}
      onHide={onCancel}
      title={"Try the new Listing Creation!"}
      bodyText={"Creating a listing is easier than ever. Switch back anytime."}
      animations={animations}
      hideMediaControllers={true}
      actions={{
        secondaryAction: {
          text: "Ask me later",
          onClick: () => {
            onCancel();
          },
        },
        primaryAction: {
          text: "Try it now",
          onClick: () => {
            onOk();
          },
        },
      }}
    />
  );
};

export default ListingFlowToggleModal;
